module.exports = __webpack_public_path__ + "img/Graph-icon16_bw.png";